import React from 'react';
import './About.css'

const About = () => {
  return (
    <>
    <main>
      <h1>About Me</h1>
      <h2>From Small Business Owner to Developer</h2>
      <p className='main-text'>I am a mother, a daughter of a first generation immigrant from Thailand, a lifetime learner, and a passionate creator.</p>
    </main>
    <section className='about-me-text-container'>
      <p className='about-me-text'>
      Hello! I'm a Denver-based software engineer with a unique journey that blends culture, entrepreneurship, and technology. As the daughter of a first-generation immigrant from Thailand, I've embraced diverse perspectives since childhood. After earning a degree in Psychology and Japanese Studies from the University of Colorado, Boulder, I co-owned a thriving restaurant for a decade, honing skills in management, communication, and creative problem-solving. My next chapter is focused on transitioning into software development, driven by my passion for problem-solving and technology.
      <br/><br/>
      With a foundation in entrepreneurship, I bring leadership, adaptability, and a unique cultural perspective to the table. I'm on the lookout for a role that marries my skills and experiences, ideally contributing to a company dedicated to enhancing user experiences by bridging cultures. 
      <br/><br/>
      Let's connect and explore how my journey can add value to your team. Reach out to me at sakisandra.c@gmail.com or message me here on LinkedIn. I'm excited to embark on this new adventure of learning, growth, and collaboration!
      </p>
    </section>
    <section className='skills'>
      <h2>My Skills</h2>
      <div className='skills-container'>
        <article className='skill-box'>
          <p className='skills-header'>Technical Skills</p>
          <ul className='skills-list'>
            <li><span>⭐️</span> React</li>
            <li><span>⭐️</span> TypeScript/ JavaScript</li>
            <li><span>⭐️</span> CSS / HTML</li>
            <li><span>⭐️</span> PostgresSQL</li>
            <li><span>⭐️</span> Accesibility Practices</li>
            <li><span>⭐️</span> GitHub Workflow</li>
            <li><span>⭐️</span> TDD -Mocha/Chai/Cypress</li>
            <li><span>⭐️</span> Express.js/Node.js</li>
            <li><span>⭐️</span> UI Design</li>
          </ul>
        </article>
        <article className='skill-box'>
          <p className='skills-header'>Soft Skills</p>
          <ul className='skills-list'>
            <li><span>🌸</span> Time Management</li>
            <li><span>🌸</span> Organization</li>
            <li><span>🌸</span> Planning</li>
            <li><span>🌸</span> Team Leadership</li>
            <li><span>🌸</span> Team Managment</li>
            <li><span>🌸</span> Interpersonal Communication</li>
            <li><span>🌸</span> Problem Solving</li>
          </ul>
        </article>
        <article className='skill-box'>
          <p className='skills-header'>Extra Skills</p>
          <ul className='skills-list'>
            <li><span>🌈</span> Brand Curation</li>
            <li><span>🌈</span> Brand Marketing</li>
            <li><span>🌈</span> Content Creation</li>
            <li><span>🌈</span> Video Editing - Final Cut Pro</li>
            <li><span>🌈</span> Social Media Management</li>
            <li><span>🌈</span> Thai</li>
          </ul>
        </article>
      </div>
    </section>
    </>
  )
}

export default About